"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Order extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'order';
        this._vat = initParams.vat;
        this._discount = initParams.discount;
        this._shippingCost = initParams.shipping_cost;
        this._orgId = initParams.org_id;
        this._physicalItems = (0, util_1.camelArray)(initParams.physical_items);
        this._subscriptionItems = (0, util_1.camelArray)(initParams.subscription_items);
        this._sessionId = initParams.session_id;
    }
    set vat(value) {
        console.error('Do not set objects this way');
    }
    get vat() {
        return this._vat;
    }
    set discount(value) {
        console.error('Do not set objects this way');
    }
    get discount() {
        return this._discount;
    }
    set shippingCost(value) {
        console.error('Do not set objects this way');
    }
    get shippingCost() {
        return this._shippingCost;
    }
    set orgId(value) {
        console.error('Do not set objects this way');
    }
    get orgId() {
        return this._orgId;
    }
    set physicalItems(value) {
        console.error('Do not set objects this way');
    }
    get physicalItems() {
        return this._physicalItems;
    }
    set subscriptionItems(value) {
        console.error('Do not set objects this way');
    }
    get subscriptionItems() {
        return this._subscriptionItems;
    }
    set sessionId(value) {
        console.error('Do not set objects this way');
    }
    get sessionId() {
        return this._sessionId;
    }
}
exports.default = Order;
//# sourceMappingURL=order.js.map